import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2FactIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 47.422 47.418",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 47.422),
    children: /*#__PURE__*/jsx("path", {
      d: "M9.812 17.072a3 3 0 00-.6 4.712L25.638 38.21a3 3 0 004.712-.6 15.044 15.044 0 001.62-11.08l13.058-8.31a3 3 0 00.512-4.652L33.853 1.882a3 3 0 00-4.652.51l-8.309 13.063a15.044 15.044 0 00-11.08 1.62zM17.42 29.998L1.414 46.004"
    })
  });
};

export { PM2FactIcon };
//# sourceMappingURL=fact.js.map
